---
title: "In pursuit of understanding human behavioral algorithms: Finding the sentimental equilibrium while humans engage with digital technologies"
slug: human-behavioral-algorithms
type: paper
status: published
featured: true
summary: A computational perspective on human behavior — the human organism as an algorithm, and sentimental equilibrium in digital engagement.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2023-10-23"
lastReviewedAt: "2026-09-18"
audiences:
  - business
  - product-developer
themes:
  - computational-social-science
  - interaction-science
sourceUrl: https://www.researchgate.net/publication/375005121_In_pursuit_of_understanding_human_behavioral_algorithms_Finding_the_sentimental_equilibrium_while_humans_engage_with_digital_technologies
originalAuthor: Jay van Zyl
sourceRelationship: first-party conference paper, full text on ResearchGate
rightsStatus: outbound-only
seoDescription: 2023 conference paper by Jay van Zyl on human behavioral algorithms and sentimental equilibrium, presented in Singapore.
canonicalPath: /research/human-behavioral-algorithms
authors:
  - Jay van Zyl
year: 2023
venue: International Congress on Behavioral and Social Science Research, Singapore
publicationType: conference
citation: "van Zyl, J. (2023, October 23). In pursuit of understanding human behavioral algorithms: Finding the sentimental equilibrium while humans engage with digital technologies. International Congress on Behavioral and Social Science Research, Singapore."
researchTheme: computational-social-science
recordUrl: https://www.researchgate.net/publication/375005121_In_pursuit_of_understanding_human_behavioral_algorithms_Finding_the_sentimental_equilibrium_while_humans_engage_with_digital_technologies
---

Presented on 23 October 2023 at the International Congress on Behavioral and Social Science Research in Singapore. The paper treats the human organism as an algorithm and asks how sentimental equilibrium holds while people engage with digital systems. Sentimental equilibrium is also a named algorithm on the platform.

The full text is the [ResearchGate publication](https://www.researchgate.net/publication/375005121_In_pursuit_of_understanding_human_behavioral_algorithms_Finding_the_sentimental_equilibrium_while_humans_engage_with_digital_technologies).
